import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  updateEletronica,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'veiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `veiculo/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));
    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'veiculo', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/Veiculos.swf');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;
    const parameters = id.split('/');
    const params = {
      wherefield: ['veic_cod_veic', 'empe_cod_emp'],
      valuewherefield: [parameters[0], parameters[1]],
      typewherefield: ['EQUALS', 'EQUALS'],
    };

    const { data } = yield call(api.get, `veiculo/`, {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    yield put(successRequest(...data.items));
  } catch (erros) {
    console.log(erros);
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'veiculo', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/Veiculos.swf');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}
export function* updateVazao({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'veiculovazao', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/Veiculos.swf');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* updateElet({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'veiculoeletronica ', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/Veiculos.swf');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'veiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@equipamento/DATA_IN_REQUEST', requestData),
  takeLatest('@equipamento/DELETE_DATA', deleteData),
  takeLatest('@equipamento/SUCCESS_REMOVE', requestData),
  takeLatest('@equipamento/STORE_DATA', store),
  takeLatest('@equipamento/FIND_DATA', find),
  takeLatest('@equipamento/UPDATE_DATA', update),
  takeLatest('@equipamento/UPDATE_VAZAO', updateVazao),
  takeLatest('@equipamento/UPDATE_ELETRONICA', updateElet),
  takeLatest('@equipamento/RECORD_FILTERING', applyedFilters),
]);
